import { GET_BUYER_PAYMENT_TRANSSACTION_URL, GET_BUYER_SINGLE_TRANSSACTION_URL, GET_PAYMENT_TRANSSACTION_URL } from "../../api";
import axiosInstance from "../../axiosInstance";

export const getPaymentTransactions = (props) => onResponse => {
    try {
        axiosInstance.post(GET_PAYMENT_TRANSSACTION_URL, props.formData)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};

export const getBuyerPaymentTransactions = () => onResponse => {
    try {
        axiosInstance.get(GET_BUYER_PAYMENT_TRANSSACTION_URL + "?status=2")
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};
export const getBuyerSingleTransactions = (task_details) => onResponse => {
    try {
        axiosInstance.get(GET_BUYER_SINGLE_TRANSSACTION_URL + "?task_details=" + task_details)
            .then((response) => {

                onResponse(response.data);
            })
            .catch((err) => {

                onResponse(err);
            });

    } catch (error) {

    }

};